<template>
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'Shop'}"
            class="btn btn-primary btn-round">
          Back
        </b-link>
      </template>
    </navbar>

    <h2 v-if="category !== null" class="font-weight-bold">{{ category.category_title }}</h2>
    <h3>You can specify that products in this category not be shipped to the countries you selected</h3>

    <b-card :title="(isShowProducts ? 'Filter Products' : 'Countries')">

      <div v-if="ids.length > 0" class="text-right">
        <template v-if="!isShowProducts">
          <b-button
              @click="getProducts($route.params.categoryid)"
              variant="primary">Products filter
          </b-button>
        </template>
        <template v-else>
          <b-button
              @click="isShowProducts=false"
              variant="danger">Back
          </b-button>
        </template>

      </div>

      <template v-if="!isShowProducts">
        <b-form-checkbox-group
            :options="items"
            class="mb-3"
            stacked
            v-model="ids"
            value-field="id"
            text-field="title"
        ></b-form-checkbox-group>
      </template>

      <template v-else>

        <p class="font-weight-bold">Select country</p>
        <b-form-select
            :options="items"
            class="mb-3"
            stacked
            v-model="countryId"
            @change="getCountryProducts"
            value-field="id"
            text-field="title"
        ></b-form-select>

        <p class="font-weight-bold">Select products</p>
        <b-alert show variant="info">If you select any product, that product will be shipped to that country</b-alert>

        <b-input v-model="searchInput" placeholder="search..."></b-input>

        <b-form-checkbox-group
            :options="getProductsSearch"
            class="mb-3"
            stacked
            v-model="idsProduct"
            value-field="id"
            text-field="title"
        ></b-form-checkbox-group>
      </template>


      <template v-if="!isShowProducts">
        <b-button
            @click="storeCountry"
            variant="success">{{ $t('saveTitle') }}
        </b-button>
      </template>
      <template v-else>
        <b-button
            @click="storeCountryProducts"
            variant="success">{{ $t('saveTitle') }}
        </b-button>
      </template>

    </b-card>


  </div>
</template>

<script>

import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import Notificaion from "../../Services/Notification/Nottification";

export default {
  name: "Index",
  components: {Navbar},
  data() {
    return {
      items: [],
      itemsProduct: [],
      category: null,
      categoryId: null,
      countryId: null,
      ids: [],
      idsProduct: [],
      isShowProducts: false,
      searchInput: null,
    }
  },
  methods: {
    getProducts(categoryid) {
      if (categoryid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'product/index', {
          categoryId: categoryid,
          filterType: null,
          subCategory: null
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.isShowProducts = true;
                this.itemsProduct = response.data.data.items;
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    getCountries() {
      if (this.$route.params.categoryid && this.$route.params.categoryid > 0) {
        this.$Progress.start();
        Http.get(Http.apiurlV2() + 'categorycountries/index/' + this.$route.params.categoryid)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.items = response.data.data.countries;
                this.ids = response.data.data.countryIds;
                this.category = response.data.data.category;
              } else {
                Notificaion.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    getCountryProducts(myCountryId) {
      if (this.$route.params.categoryid && this.$route.params.categoryid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'categorycountries/products/' + this.$route.params.categoryid, {
          countryId: myCountryId
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.idsProduct = response.data.data.productIds;
              } else {
                Notificaion.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
    storeCountry() {

      if (this.$route.params.categoryid && this.$route.params.categoryid > 0) {


        this.$Progress.start();

        Http.post(Http.apiurlV2() + 'categorycountries/update/' + this.$route.params.categoryid, {
          ids: this.ids,
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getCountries();
                Notificaion.success(response.data.message)
              } else {
                Notificaion.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            });
      }
    },
    storeCountryProducts() {

      if (this.$route.params.categoryid && this.$route.params.categoryid > 0) {

        if (this.countryId == null) {
          Notificaion.error("Please select country")
          return;
        }

        this.$Progress.start();

        Http.post(Http.apiurlV2() + 'categorycountries/update/products/' + this.$route.params.categoryid, {
          productIds: this.idsProduct,
          countryId: this.countryId,
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                Notificaion.success(response.data.message)
              } else {
                Notificaion.error(response.data.message)
              }
            })
            .catch(error => {
              this.$Progress.finish();
            });
      }
    },
  },
  computed:{
    getProductsSearch() {
      if (this.searchInput === null) {
        return this.itemsProduct;
      }

      return this.itemsProduct.filter(item => {
        return item.title.toLowerCase().match(this.searchInput.toLowerCase())
      })
    },
  },
  created() {
    this.getCountries();
  }
}
</script>

<style scoped>

</style>